 document.addEventListener("DOMContentLoaded", function () {

/*
  Add-to-Cart - Collection page */
  document.querySelectorAll(".quick-add__submit").forEach(function (button) {
    button.addEventListener("click", function () {
      // Find the closest product card wrapper for the clicked button
      const productCard = button.closest(".product-card-wrapper");
      if (!productCard) return;
      const mediaCard = productCard.querySelector(".card__media");
        if (!mediaCard) return;
      // Clone the media card
      const clone = mediaCard.cloneNode(true);

      // Get the product card's position and dimensions relative to the viewport
      const rect = mediaCard.getBoundingClientRect();

      // Set initial styles for the clone so it overlays the original element
      clone.style.position = "fixed";
      clone.style.top = rect.top + "px";
      clone.style.left = rect.left + "px";
      clone.style.width = rect.width + "px";
      clone.style.height = rect.height + "px";
      clone.style.zIndex = "9999";
      clone.style.pointerEvents = "none";

      // Optionally add a class for additional styling
      clone.classList.add("fly-clone");

      // Append the clone to the body
      document.body.appendChild(clone);

      // Get the destination coordinates from the header icons element

      var cart_element = ".header__icons";
      if (window.innerWidth < 989) {
        cart_element = ".header__icons .header__icon--cart";
      }
      const cartIcon = document.querySelector(cart_element);
       
      if (cartIcon) {
        const iconRect = cartIcon.getBoundingClientRect();

        // Calculate the difference between the centers of the product card and the header icon
        const deltaX = iconRect.left + iconRect.width / 2 - (rect.left + rect.width / 2);
        const deltaY = iconRect.top + iconRect.height / 2 - (rect.top + rect.height / 2);
      
        // Apply a smooth transition to animate the clone moving towards the header icon
        clone.style.transition = "transform 1s ease-in-out, opacity 1s ease-in-out";
        clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
        clone.style.opacity = "0";
      }

      // Remove the clone after the animation completes
      setTimeout(function () {
        clone.remove();
      }, 1000);
    });
  });
  


  /*
  Add-to-Cart - Related Products 
  */
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".add-to-cart-ajax");
    if (!button) return;

    const variantId = button.getAttribute("data-variant-id");
    if (!variantId) return;

    // Show loading state
    button.textContent = "Adding...";
    button.disabled = true;

    var el = button.closest('.grid__item');
    //console.log(el);
    if (!el) {
      console.warn('No .grid__item found');
      return;
    }

    var typeEl = el.querySelector(".product--info");
    var cart_ = null;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _parent_id: el.getAttribute("parent-id") || "",
            _parent_name: el.getAttribute("parent-name") || "",
            _affiliation: (typeEl && typeEl.dataset.origin) || "",
            _treatment: (typeEl && typeEl.dataset.treatment) || "",
            _listing: (typeEl && typeEl.dataset.publish) || ""
          }
        })
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(data => {
      // Show success state
      setTimeout(() => {
          button.classList.add('add_cart_success');
         button.textContent = '✔ Added';
      }, 500);
      setTimeout(() => {
              button.classList.remove('add_cart_success');
              button.textContent = 'Added';
          }, 3000);
      document.dispatchEvent(new CustomEvent("product:added", { detail: data }));

      // Fetch cart state
      return fetch("/cart.js").then(res => res.json());
    })
    .then(cart => {
      cart_ = cart;
      // Update cart count
      // Update cart icon bubble inside #cart-icon-bubble
      const cartIconBubble = document.getElementById("cart-icon-bubble");

      if (cartIconBubble) {
        // Remove existing bubble first
        const existingBubble = cartIconBubble.querySelector(".cart-count-bubble");
        if (existingBubble) {
          existingBubble.remove();
        }

        // Add new bubble only if cart has items
        if (cart.item_count > 0) {
          const bubbleHTML = `
            <div class="cart-count-bubble">
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} ${cart.item_count === 1 ? "item" : "items"}</span>
            </div>
          `;

          cartIconBubble.insertAdjacentHTML("beforeend", bubbleHTML);
        }
      }

      // start
      var sizeEl = el.querySelector(".product-size");
      var priceEl = el.querySelector(".price-item--regular .money");

      // Detect platform
      var isMobile = window.matchMedia("(max-width: 768px)").matches;
      var platform = isMobile ? "m-web" : "d-web";

      var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

      var item = {
        item_id: (typeEl && typeEl.dataset.sku) || el.dataset.id || variantId,
        item_name: el.dataset.title || "",
        index: parseInt(el.dataset.index) || 0,
        affiliation: (typeEl && typeEl.dataset.origin) || "",
        item_category: (typeEl && typeEl.dataset.type) || "",
        item_category2: (typeEl && typeEl.dataset.treatment) || "",
        item_variant: (sizeEl && sizeEl.dataset.size) || "",
        item_list_id: el.getAttribute("parent-id") || "",
        item_list_name: el.getAttribute("parent-name") || "",
        price: parseInt((typeEl && typeEl.dataset.price) || 0, 10),
        quantity: 1,
        item_brand: "Gemstones For Sale",
        coupon:"NA",
        listing_date : (typeEl && typeEl.dataset.publish) || "",
        discount : 0,
      };

      var value = item.price;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });

      window.dataLayer.push({
        event: 'add_to_cart_ce',
        page_type: window.GA_CONTEXT?.page_type || "",
        platform: platform,
        total_qty : 1,
        user_id_event: window.GA_CONTEXT?.user_id,
        user_status: window.GA_CONTEXT?.user_status || "guest",
        ecommerce: {
          currency: "USD",
          value: value,
          items: [item]
        }
      });
      
       // ── NEW: publish custom event so CE pixel can receive it ──
        if (window.Shopify?.analytics?.publish) {
          const publishPayload = {
            item_list_id: item.item_list_id,
            item_list_name: item.item_list_name,
            item_category2: item.item_category2,
            affiliation: item.affiliation,
            listing_date: item.listing_date,
            index: item.index
          };

          console.log("[DEV] Publishing ga4_product_context with:", publishPayload);
          window.Shopify.analytics.publish('ga4_product_context', publishPayload);
        }

      // return this fetch!
      return fetch('/?sections=cart-drawer');
    })
    .then(res => res.json())
    .then(data => {
      const newDrawerHTML = data['cart-drawer'];
      const parser = new DOMParser();
      const doc = parser.parseFromString(newDrawerHTML, 'text/html');

      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        const cartDrawerParent = currentDrawer ? currentDrawer.closest("cart-drawer") : null;
        //console.log(cart_);
        // Remove empty state if cart has items
        if (cartDrawerParent && cart_ && cart_.item_count > 0) {
          cartDrawerParent.classList.remove("is-empty");
        }
        //console.log("Cart drawer updated.");
      } else {
        console.warn("Cart drawer structure not found in DOM.");
      }
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
      button.textContent = '✖ Error';
      button.disabled = false;
    });
});


  /*
  homepage category scrollBar
  */
   const slideshow_container = document.querySelector('.slideshow-slider-container');
   const categorySlider = document.querySelector('.slideshow_v2 .slideshow_v2_slider');
    const categoryProgressBar = document.querySelector('.slideshow_v2 .progress');
    const categoryProgressBarLabel = document.querySelector('.slideshow_v2 .slider__label');
if(categorySlider){
    categorySlider.addEventListener('scroll', function () {
      const scrollLeft = categorySlider.scrollLeft;
      const maxScrollLeft = categorySlider.scrollWidth - categorySlider.clientWidth;
      const calc = (scrollLeft / maxScrollLeft) * 100;
      const roundedCalc = Math.round(calc);
    
      categoryProgressBar.style.backgroundSize = `${calc}% 100%`;
      categoryProgressBar.setAttribute('aria-valuenow', roundedCalc);
   //   categoryProgressBarLabel.textContent = `${roundedCalc}% completed`;
    });

    const leftArrow = document.querySelector('.slideshow-left-arrow');
    const rightArrow = document.querySelector('.slideshow-right-arrow');
    
    const scrollAmount = 350;
    
    leftArrow.addEventListener('click', () => {
       if (categorySlider.scrollLeft > 0) {
         categorySlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
       }
    });
    
    rightArrow.addEventListener('click', () => {
       const maxScrollLeft = categorySlider.scrollWidth - categorySlider.clientWidth;
        if (categorySlider.scrollLeft < maxScrollLeft) {
             categorySlider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    });
}
	
	 /*
  Shopby-Tabbing 
  */
  const shopbytabButtons = document.querySelectorAll('#shopby-tab-container .tab-button');
  const shopbytabContents = document.querySelectorAll('#shopby-tab-container .tab-content');

  if(shopbytabButtons && shopbytabContents){
   // dot navigation 
  const loadTabElement = document.getElementById('shop-color');
   if(loadTabElement){
      setupDotScrollTracking(loadTabElement);
   }

  shopbytabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-tab');

      // Remove active class from all
      shopbytabButtons.forEach(btn => btn.classList.remove('active'));
      shopbytabContents.forEach(content => content.classList.remove('active'));

      // Add active class to selected
      button.classList.add('active');
      document.getElementById(target).classList.add('active');
      const activeTabElement = document.getElementById(target);
      
      // data-link
       let shopbyShapeCTA;
      if (window.innerWidth < 1200) {
        shopbyShapeCTA = document.querySelector('.tab-content.active .shopby-collections-bottom .Shopby-cta a');
      } else {
        shopbyShapeCTA = document.querySelector('.Shopby-cta a');
      }
      if(shopbyShapeCTA){
        if(target == 'shop-shape' || target == 'shop-color'){
         const active_shopShape = document.getElementById(target).querySelector('.shopby-item.active');
         const datalink = active_shopShape.getAttribute('data-link');
         const dataId = active_shopShape.getAttribute('data-id').toLowerCase(); 
         if (datalink) {
            shopbyShapeCTA.setAttribute('href', datalink);
            shopbyShapeCTA.querySelector('span').innerHTML = dataId;
          }else{
             shopbyShapeCTA.setAttribute('href', 'https://www.gemstonesforsale.com/a/search?q='+dataId);
              shopbyShapeCTA.querySelector('span').innerHTML = dataId;
          }
        }else{
              shopbyShapeCTA.setAttribute('href', 'https://www.gemstonesforsale.com/collections');
              shopbyShapeCTA.querySelector('span').innerHTML = 'Collections';
          }
      }
      // dot navigation 
      setupDotScrollTracking(activeTabElement);
    });
  });

  
    fetch('https://www.gemstonesforsale.com/pages/about-us?view=shopby-categories')
    .then(response => response.json())
    .then(data => {
        const shopby_data = data;
        // Attach click event to all anchor tags in .shopby-variation
        document.querySelectorAll('.shopby-variation > div').forEach(anchor => {
          anchor.addEventListener('click', function (e) {
            e.preventDefault();
            // active class
             const parentDiv = this.closest('.shopby-variation');

            // Remove class from all anchors within the same parent div only
            parentDiv.querySelectorAll('div').forEach(a => {
              a.classList.remove('active'); // replace 'active' with your class
            });
        
            // Add class to the clicked anchor
            this.classList.add('active');
            
            // data-id
            const dataId = this.getAttribute('data-id').toLowerCase(); // e.g., "square" or "circle"
            let found = false;
            let itemsArray = null;
            shopby_data.categories.forEach(category => {
              // Get the category key (like "color" or "shape")
              const categoryKey = Object.keys(category)[0];
              const items = category[categoryKey];
        
              items.forEach(item => {
                const itemKey = Object.keys(item)[0]; // e.g., "Square", "Circle"
                if (itemKey.toLowerCase() === dataId) {
                  if (!itemsArray) {
                      itemsArray = []; // initialize if null
                    }
                    // Use spread because item[itemKey] is an array (of objects)
                    itemsArray.push(...item[itemKey]);
                    found = true;
                }
              });
            });
        
            if (found && itemsArray && itemsArray.length > 0) {
               //
              const newCards = createCollectionCards(itemsArray);
                // Find parent .shopby-container and replace .shopby-collections
                const tabContent = anchor.closest('.shopby-container');
                const oldCollection = tabContent.querySelector('.shopby-collections');
                const parent = oldCollection?.parentNode;

                if (oldCollection && parent && parent.contains(oldCollection)) {
                  parent.replaceChild(newCards, oldCollection);
                } else {
                  console.warn("Can't replace: .shopby-collections not found or not attached.");
                }
              }else{
              console.log(`No match found for: ${dataId}`);
            }

            // data-link
            const datalink = this.getAttribute('data-link');
           let shopbyShapeCTA;
            if (window.innerWidth < 1200) {
              shopbyShapeCTA = document.querySelector('.tab-content.active .shopby-collections-bottom .Shopby-cta a');
            } else {
              shopbyShapeCTA = document.querySelector('.Shopby-cta a');
            }
            if(shopbyShapeCTA){
              if (datalink) {
                shopbyShapeCTA.setAttribute('href', datalink);
                shopbyShapeCTA.querySelector('span').innerHTML = dataId;
              }else{
                 shopbyShapeCTA.setAttribute('href', 'https://www.gemstonesforsale.com/a/search?q='+dataId);
                  shopbyShapeCTA.querySelector('span').innerHTML = dataId;
              }
            }
          });
        });
    });

    /* create collection array */  
    function createCollectionCards(itemsArray) {
      // Create a container for the new cards
      const container = document.createElement('div');
      container.className = 'shopby-collections'; // match the one we are replacing
    
      itemsArray.forEach(item => {
        const card = document.createElement('div');
        card.className = '_collection__card';
    
        const anchor = document.createElement('a');
        anchor.href = item.url;
    
        const mediaDiv = document.createElement('div');
        mediaDiv.className = '_collection__media';
    
        const img = document.createElement('img');
        img.src = item.image;
        img.width = 150;
        img.height = 150;
    
        mediaDiv.appendChild(img);
    
        const contentDiv = document.createElement('div');
        contentDiv.className = '_collection__content';

        if(item.price){
           const priceDiv = document.createElement('div');
          priceDiv.className = '__price';
          priceDiv.innerHTML  = item.price;
          contentDiv.appendChild(priceDiv);
        }

        const titleDiv = document.createElement('div');
        titleDiv.className = '_collection__title';
        titleDiv.textContent = item.title;
        contentDiv.appendChild(titleDiv);
        
        anchor.appendChild(mediaDiv);
        anchor.appendChild(contentDiv);
        card.appendChild(anchor);
        container.appendChild(card);
      });
    
      return container;
    }


  // dot navigation
      function setupDotScrollTracking(tabElement) {
        const scrollContent = tabElement.querySelector('.mobile-scroller');
        const dots = tabElement.querySelectorAll('.dot');
      
        if (!scrollContent || dots.length === 0) return;
      
        scrollContent.addEventListener('scroll', () => {
          const scrollLeft = scrollContent.scrollLeft;
          const maxScroll = scrollContent.scrollWidth - scrollContent.clientWidth;
          const scrollPercent = scrollLeft / maxScroll;
      
          let index = 0;
          if (scrollPercent >= 0.66) {
            index = 2;
          } else if (scrollPercent >= 0.33) {
            index = 1;
          }
      
          dots.forEach(dot => dot.classList.remove('active'));
          if (dots[index]) dots[index].classList.add('active');
        });
      }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // A–Z sticky bar scroll (scoped to submenu only)
  document.querySelectorAll('.desktop_gemstone_list .alphabet-scroll a').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').slice(1);
      const submenu = this.closest('.sub-menu');
      if (!submenu) return;

      //  Only look for the target inside the submenu
      const targetEl = submenu.querySelector('#' + CSS.escape(targetId));
      if (!targetEl) return; // stop if not found in submenu

      //  Calculate how far to scroll inside submenu
      const submenuRect = submenu.getBoundingClientRect();
      const targetRect = targetEl.getBoundingClientRect();
      const scrollOffset = targetRect.top - submenuRect.top + submenu.scrollTop - 50; // adjust 50 for sticky bar height

      submenu.scrollTo({
        top: scrollOffset,
        behavior: 'smooth'
      });
    });
  });


  // --- Sticky Search Header ---
  const stickySearchHeader = document.querySelector('.sticky-search-header');
  if (stickySearchHeader) {
    stickySearchHeader.addEventListener('click', function (e) {
      e.preventDefault();

      // Scroll to top of body
      window.scrollTo({
        top: document.body.offsetTop,
        behavior: 'smooth' // smooth scroll
      });

      // Focus the search input
      const searchInput = document.querySelector('#search-input');
      if (searchInput) {
        searchInput.focus();
      }
    });
  }

  // --- Mobile dropdown toggle ---
  let lastClicked = null;
  if (window.innerWidth < 980) {
    const dropdownMenus = document.querySelectorAll('.custom_mega_menu .dropdown_menu');
    dropdownMenus.forEach(function (menu) {
      menu.addEventListener('click', function () {
        // Remove 'active_menu' from previously clicked element
        if (lastClicked && lastClicked !== menu) {
          lastClicked.classList.remove('active_menu');
        }

        // Toggle 'active_menu' class
        menu.classList.toggle('active_menu');

        // Update lastClicked
        lastClicked = menu;
      });
    });
  }
});

/* slideshow - v2 */
jQuery(document).ready(function($) {
  var $slider = $('.slideshow_v2 .slideshow_v2_slider');
  var $progressBar = $('.slideshow_v2 .progress');
  var $progressBarLabel = $( '.slideshow_v2 .slider__label' );

  var $testimonial_slider = $('.testimonial_v2 .testimonial_v2_slider');
   if($testimonial_slider.length > 0){
      $testimonial_slider.slick({
           slidesToShow: 3,
          slidesToScroll: 1,
       //autoplay: true,
        dots:false,
        //arrow:true,
        prevArrow: '<button type="button" class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 8.25 6" height="25" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="1534deb356"><path d="M 0.960938 2.320312 L 2.390625 2.320312 L 2.390625 3.679688 L 0.960938 3.679688 Z M 0.960938 2.320312 " clip-rule="nonzero"/></clipPath><clipPath id="3c7a86f96c"><path d="M 1.675781 2.320312 L 1.84375 2.839844 L 2.390625 2.839844 L 1.949219 3.160156 L 2.117188 3.679688 L 1.675781 3.359375 L 1.234375 3.679688 L 1.402344 3.160156 L 0.960938 2.839844 L 1.507812 2.839844 Z M 1.675781 2.320312 " clip-rule="nonzero"/></clipPath><clipPath id="cde8152031"><path d="M 0 2 L 7.5625 2 L 7.5625 4 L 0 4 Z M 0 2 " clip-rule="nonzero"/></clipPath><clipPath id="9e2e77315d"><path d="M 0 0.25 L 5 0.25 L 5 5.75 L 0 5.75 Z M 0 0.25 " clip-rule="nonzero"/></clipPath></defs><g clip-path="url(#1534deb356)"><g clip-path="url(#3c7a86f96c)"><path fill="#fbc324" d="M 0.960938 2.320312 L 2.390625 2.320312 L 2.390625 3.679688 L 0.960938 3.679688 Z M 0.960938 2.320312 " fill-opacity="1" fill-rule="nonzero"/></g></g><g clip-path="url(#cde8152031)"><path stroke-linecap="butt" transform="matrix(0.6875, -0.000000000000014494, 0.000000000000014494, 0.6875, -0.000000000000014655, 2.3125)" fill="none" stroke-linejoin="miter" d="M 1 1 L 10.755682 1 " stroke="#545657" stroke-width="2" stroke-opacity="1" stroke-miterlimit="4"/></g><g clip-path="url(#9e2e77315d)"><path stroke-linecap="round" transform="matrix(0.6875, -0.000000000000014494, 0.000000000000014494, 0.6875, -0.000000000000014655, 2.3125)" fill="none" stroke-linejoin="round" d="M 5 -2 L 1 1 L 5 4 " stroke="#545657" stroke-width="2" stroke-opacity="1" stroke-miterlimit="4"/></g></svg></button>',
        nextArrow: '<button type="button" class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" zoomAndPan="magnify" viewBox="0 0 8.25 6" height="25" preserveAspectRatio="xMidYMid meet" version="1.0"><defs><clipPath id="1dd938c2b1"><path d="M 4.902344 2.539062 L 6.109375 2.539062 L 6.109375 3.6875 L 4.902344 3.6875 Z M 4.902344 2.539062 " clip-rule="nonzero"/></clipPath><clipPath id="15bc2d48da"><path d="M 5.503906 2.539062 L 5.644531 2.976562 L 6.105469 2.976562 L 5.734375 3.25 L 5.875 3.6875 L 5.503906 3.417969 L 5.128906 3.6875 L 5.273438 3.25 L 4.902344 2.976562 L 5.359375 2.976562 Z M 5.503906 2.539062 " clip-rule="nonzero"/></clipPath><clipPath id="f30ee3fe4c"><path d="M 4.902344 2.320312 L 6.328125 2.320312 L 6.328125 3.679688 L 4.902344 3.679688 Z M 4.902344 2.320312 " clip-rule="nonzero"/></clipPath><clipPath id="ce9774445a"><path d="M 5.613281 2.320312 L 5.78125 2.839844 L 6.328125 2.839844 L 5.886719 3.160156 L 6.054688 3.679688 L 5.613281 3.359375 L 5.171875 3.679688 L 5.339844 3.160156 L 4.902344 2.839844 L 5.445312 2.839844 Z M 5.613281 2.320312 " clip-rule="nonzero"/></clipPath><clipPath id="efd00ab320"><path d="M 0 2 L 7.5625 2 L 7.5625 4 L 0 4 Z M 0 2 " clip-rule="nonzero"/></clipPath><clipPath id="5d6199bd8f"><path d="M 3 0.25 L 7.5625 0.25 L 7.5625 5.75 L 3 5.75 Z M 3 0.25 " clip-rule="nonzero"/></clipPath></defs><g clip-path="url(#1dd938c2b1)"><g clip-path="url(#15bc2d48da)"><path fill="#fbc324" d="M 4.902344 2.539062 L 6.109375 2.539062 L 6.109375 3.6875 L 4.902344 3.6875 Z M 4.902344 2.539062 " fill-opacity="1" fill-rule="nonzero"/></g></g><g clip-path="url(#f30ee3fe4c)"><g clip-path="url(#ce9774445a)"><path fill="#fbc324" d="M 4.902344 2.320312 L 6.328125 2.320312 L 6.328125 3.679688 L 4.902344 3.679688 Z M 4.902344 2.320312 " fill-opacity="1" fill-rule="nonzero"/></g></g><g clip-path="url(#efd00ab320)"><path stroke-linecap="butt" transform="matrix(0.6875, -0.000000000000014494, 0.000000000000014494, 0.6875, -0.000000000000014655, 2.3125)" fill="none" stroke-linejoin="miter" d="M 0.000000000000000234 1 L 9.755682 1 " stroke="#545657" stroke-width="2" stroke-opacity="1" stroke-miterlimit="4"/></g><g clip-path="url(#5d6199bd8f)"><path stroke-linecap="round" transform="matrix(0.6875, -0.000000000000014494, 0.000000000000014494, 0.6875, -0.000000000000014655, 2.3125)" fill="none" stroke-linejoin="round" d="M 5.755682 -2 L 9.755682 1 L 5.755682 4 " stroke="#545657" stroke-width="2" stroke-opacity="1" stroke-miterlimit="4"/></g></svg></button>',
          speed: 1000,
        draggable:true,
        touchThreshold: 10,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              speed : 500
            }
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              speed : 500,
              dots:true,
              arrow:false
            }
          }
        ]
      }); 
    
       $testimonial_slider.on('wheel', (function(e) {
        if (e.originalEvent.deltaX > 0 && e.originalEvent.deltaX != 0) {
            e.preventDefault();
            $(this).slick('slickNext');
        } else  if (e.originalEvent.deltaX < 0 && e.originalEvent.deltaX != 0) {
            e.preventDefault();
            $(this).slick('slickPrev');
        }
    }));
   }
});

/* for opal like collection sub-category */
document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const container = document.getElementById('opal-subcategory');
  if (!container) return; 

  const filterCollection = params.get('filter_collection');
  if (!filterCollection) return;

  document.querySelectorAll('#opal-subcategory .sub-filter-cat').forEach(li => {
    if (li.dataset.id === filterCollection) {
      li.classList.add('active');
    } else {
      li.classList.remove('active');
    }
  });
});

/* forcefully closing filter */
document.addEventListener('DOMContentLoaded', function () {
  let activeFilterName = null;
  let isSyntheticClick = false;

  document.addEventListener(
    'click',
    function (e) {
      const header = e.target.closest('.cloud-search-filter__name');
      if (!header) return;

      if (window.innerWidth < 990) return;

      const filter = header.closest('.cloud-search-filter');
      const filterName = filter.getAttribute('data-filter-name');

      // If this is a synthetic click, let it pass only for closing
      if (isSyntheticClick) {
        // prevent this click from affecting other filters
        return;
      }

      // real user click
      activeFilterName = filterName;

      // Let XCloud open current filter first
      setTimeout(() => {
        document.querySelectorAll('.cloud-search-filter').forEach((item) => {
          const name = item.getAttribute('data-filter-name');
          if (name === activeFilterName) return;

          const isOpen =
            item.querySelector('.cloud-search-filter__values') ||
            item.querySelector('.cloud-search-range-inputs');

          if (isOpen) {
            const headerEl = item.querySelector('.cloud-search-filter__name');
            if (!headerEl) return;

            //  mark as synthetic
            isSyntheticClick = true;
            headerEl.click();
            isSyntheticClick = false;
          }
        });
      }, 80);
    },
    true
  );
});

/* for blog sub-category */
document.addEventListener('DOMContentLoaded', function () {
  const heading = document.querySelector('.blog-category-heading');
  const targetEle = document.querySelector('.blog-cat-nav');
  let scrolled = false;

  if (heading && targetEle) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0 && !scrolled) {
        targetEle.classList.add('is-scrolled');
        scrolled = true;
      } else if (window.scrollY === 0 && scrolled) {
        targetEle.classList.remove('is-scrolled');
        scrolled = false;
      }
    });
  }

  const blogList = document.querySelector('.blog-list');
  const header = document.querySelector('.blog-category-header');
  if (blogList && header){

    let blogListVisible = false;

    // Observe blog-list visibility (paint / viewport)
    const observer = new IntersectionObserver(
      ([entry]) => {
        blogListVisible = entry.isIntersecting;
        toggleClass();
      },
      { threshold: 0 }
    );

    observer.observe(blogList);

    // Scroll listener
    window.addEventListener('scroll', toggleClass);

    function toggleClass() {
      if (window.scrollY > 0 && blogListVisible) {
        header.classList.add('is-fixed');
      } else {
        header.classList.remove('is-fixed');
      }
    }
  }
});

/** remove cart drawer */
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("click", function (e) {

    var removeBtn = e.target.closest(".cart-remove-button");
    if (!removeBtn) return;

    // Find cart item row
    var cartItem = removeBtn.closest(".cart-item");
    if (!cartItem) return;

    // Get product info div
    var productInfo = cartItem.querySelector(".product--info");
    if (!productInfo) return;

    // Extract data
    var productId = productInfo.dataset.id;
    var productTitle = productInfo.dataset.title;
    var productType = productInfo.dataset.type;
    var sku = productInfo.dataset.sku;
    var size = productInfo.dataset.size;
    var origin = productInfo.dataset.origin;
    var treatment = productInfo.dataset.treatment;
    var parentId = productInfo.dataset.parent_id;
    var parentTitle = productInfo.dataset.parent_title;
    var publish = productInfo.dataset.publish;
    var item_index = parseInt(productInfo.dataset.item_index);
    // Quantity
    var quantity = 1;

    // Price (clean number)
    var price = productInfo.dataset.price;
  /*  var priceEl = cartItem.querySelector(".money");
    var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;*/

    // Platform detect
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "remove_from_cart_ce",
      page_type: window.GA_CONTEXT?.page_type || "cart",
      total_qty : 1,
      platform: platform,
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status,
      ecommerce: {
        currency : "USD",
        value : price,
        items: [{
          item_id: sku,
          item_name: productTitle,
          affiliation: origin,
          item_category: productType,
          item_category2: treatment,
          item_variant: size,
          item_list_id: parentId,
          item_list_name: parentTitle,
          price: price,
          quantity: quantity,
          listng_date : publish,
          item_brand: "Gemstones For Sale",
          coupon:"NA",
          discount : 0,
          index : item_index
        }]
      }
    });

  });
});

// listing cart drawer data-layer
(function () {

  function getPlatform() {
    return window.matchMedia("(max-width: 768px)").matches ? "m-web" : "d-web";
  }

  function getCartItems() {
    var items = [];

    document.querySelectorAll('.cart-item').forEach(function (item) {

      var productInfo = item.querySelector('.product--info');
      if (!productInfo) return;

      var qty = 1;
      var priceRaw = item.querySelector('.money')?.getAttribute('original_price');
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

      items.push({
        item_id: productInfo.dataset.id,
        item_name: productInfo.dataset.title,
        affiliation: productInfo.dataset.origin,
        item_category: productInfo.dataset.type,
        item_category2: productInfo.dataset.treatment,
        item_variant: productInfo.dataset.size,
        item_list_id: productInfo.dataset.parent_id,
        item_list_name: productInfo.dataset.parent_title,
        price: productInfo.dataset.price,
        quantity: 1,
        listng_date : productInfo.dataset.publish,
        item_brand: "Gemstones For Sale",
        coupon:"NA",
        discount : 0,
        index : parseInt(productInfo.dataset.item_index)
      });

    });

    return items;
  }

  function getCartTotal() {
    var el = document.querySelector('.totals__total-value .money');
    if (!el) return 0;

    var priceRaw = el.getAttribute('original_price');
    var value = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

    return value ? value : 0;
  }

  function fireViewCart() {

    var items = getCartItems();
    if (!items.length) return;

   // console.log(items);

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "view_cart_ce",
      page_type: window.GA_CONTEXT?.page_type || "cart",
      total_qty : items.length,
      platform: getPlatform(),
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status,
      ecommerce: {
        currency : "USD",
        value : getCartTotal(),
        items: items
      }
    });

    console.log("view_cart fired");
  }

  function initCartTracking() {

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasOpen = false;

    var observer = new MutationObserver(function () {

      var isOpen = drawer.classList.contains('active');
      
      // Fire ONLY when it transitions from closed → open
      if (isOpen && !wasOpen) {
        fireViewCart();
      }

      wasOpen = isOpen;

    });

    observer.observe(drawer, { attributes: true });

  }

  document.addEventListener("DOMContentLoaded", initCartTracking);

  /*document.addEventListener("click", function (e) {

    var btn = e.target.closest('#CartDrawer-Checkout');
    if (btn){

      var items = getCartItems();
      if (!items.length) return;

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({ ecommerce: null });

      window.dataLayer.push({
        event: "begin_checkout_ce",
        page_type: window.GA_CONTEXT?.page_type || "cart",
        total_qty : items.length,
        platform: getPlatform(),
        user_id_event: window.GA_CONTEXT?.user_id,
        user_status: window.GA_CONTEXT?.user_status,
        ecommerce: {
          currency : "USD",
          value : getCartTotal(),
        coupon:"NA",
          items: items
        }
      });
    }
    
  });
  */
  document.addEventListener("DOMContentLoaded", function () {

   /* document.addEventListener("click", function (e) {

      const btn = e.target.closest("#checkout");

      if (btn) {

        const items = getCartItems();

        if (!items || !items.length) return;

        window.dataLayer = window.dataLayer || [];

        // CLEAR PREVIOUS ECOMMERCE
        window.dataLayer.push({ ecommerce: null });

        // BEGIN CHECKOUT EVENT
        window.dataLayer.push({
          event: "begin_checkout_ce",
          page_type: window.GA_CONTEXT?.page_type || "cart",
          total_qty: items.length,
          platform: getPlatform(),
          user_id_event: window.GA_CONTEXT?.user_id || "",
          user_status: window.GA_CONTEXT?.user_status || "guest",

          ecommerce: {
            currency: "USD",
            value: getCartTotal(),
            coupon: "NA",
            items: items
          }
        });

      }

    });
      */
    // cart page
    if (window.location.pathname === "/cart") {
          fireViewCart();
    }

  });

})();